module.exports = __webpack_public_path__ + "static/media/hr-exec.0fb5960a.jpg";